import React, { useEffect } from "react";
import { DataItem } from "../../common/dummydata/Dummy";
import styles from "../modal/modal.module.scss";
import { GiCancel } from "react-icons/gi";
import Slider from "react-slick";
interface Iprops {
  items: DataItem[];
  data: DataItem[];
  setModal: (newValue: boolean) => void;
  selected: number;
  setOpen: (n: boolean) => void;
}
const Modal = ({ items, setModal, data, selected, setOpen }: Iprops) => {
  var settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: <CustomNextArrow />, // Use the custom component here
    // prevArrow: <CustomPrevArrow />,
  };
  return (
    <div className={`${styles.mainWrapper} modal_slide`}>
      <div className={styles.cross}>
        {" "}
        <GiCancel
          onClick={() => {
            setModal(false);
            setOpen(true);
          }}
        />
      </div>
      <Slider
        className={styles.main_slide}
        {...settings}
        initialSlide={selected | 0}
      >
        {data.map((item, index) => (
          <div key={index} className={styles.head}>
            <p>{item.head}</p>
            <span>{item.label}</span>
            <img src={item.image} alt={item.label} />
          </div>
        ))}
      </Slider>
    </div>
  );
};
export default Modal;
